/** Small playful landmark hint next to country title (not used in lists). */
const LANDMARKS: Record<string, string> = {
  FR: '🗼',
  IT: '🏛️',
  GB: '🕰️',
  ES: '🏟️',
  DE: '🏰',
  NL: '🌷',
  AT: '🎻',
  CZ: '🏰',
  GR: '🏛️',
  PT: '🌊',
  CH: '🏔️',
  BE: '🍫',
  HU: '🛁',
  PL: '🏰',
  IE: '🍀',
  DK: '🧜',
  SE: '🦌',
  NO: '⛰️',
  FI: '🦌',
  HR: '🌊',
  TR: '🕌',
};

export function countryLandmarkEmoji(countryId: string): string {
  return LANDMARKS[countryId.toUpperCase()] || '✈️';
}
